// Author yjb
// Date 2022-02-07 14:49:16

class ImfEmSicIesmrStatusIesmrs {
constructor({
        id = null,
        name = '',
        parentId = '',
        seq = '',
        remark = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.parentId = parentId;
    this.seq = seq;
    this.remark = remark;
}
}

function newEntity() {
return new ImfEmSicIesmrStatusIesmrs();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.statusCollection.imfEmSicIesmrStatusIesmrs.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'name',
        label: 'label.em.statusCollection.imfEmSicIesmrStatusIesmrs.grid.name',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'parentId',
        label: 'label.em.statusCollection.imfEmSicIesmrStatusIesmrs.grid.parentId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'level',
        label: 'label.em.statusCollection.imfEmSicIesmrStatusIesmrs.grid.level',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'nodeCode',
        label: 'label.em.statusCollection.imfEmSicIesmrStatusIesmrs.grid.nodeCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'seq',
        label: 'label.em.statusCollection.imfEmSicIesmrStatusIesmrs.grid.seq',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.imfEmSicIesmrStatusIesmrs.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    nameFilter : '',
    parentIdFilter : '',
    levelFilter : '',
    nodeCodeFilter : '',
    seqFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.statusCollection.imfEmSicIesmrStatusIesmrs.filter.name',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'levelFilter',
        label: 'label.em.statusCollection.imfEmSicIesmrStatusIesmrs.filter.level',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'nodeCodeFilter',
        label: 'label.em.statusCollection.imfEmSicIesmrStatusIesmrs.filter.nodeCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.statusCollection.imfEmSicIesmrStatusIesmrs.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'parentId',
        label: 'label.em.statusCollection.imfEmSicIesmrStatusIesmrs.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'imfEmSicIesmrStatusIesmrs'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'seq',
        label: 'label.em.statusCollection.imfEmSicIesmrStatusIesmrs.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.imfEmSicIesmrStatusIesmrs.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {ImfEmSicIesmrStatusIesmrs, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
